export class ListSqlQueryExecutionsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "sqlQueryExecutions",
            "baseName": "sqlQueryExecutions",
            "type": "Array<SqlQueryExecution>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSqlQueryExecutionsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
